import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import useResponsiveInfo from "../../../hooks/useResponsiveInfo";

export const EnvironmentBanner: React.FC = () => {
  const env = (process.env.REACT_APP_ENV || (process.env.NODE_ENV === "development" ? "DEV" : "")).toUpperCase();
  const { isDesktop, isTablet, isMobile } = useResponsiveInfo();
  const location = useLocation();
  
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("spm_sidebar_collapsed") === "true";
  });

  useEffect(() => {
    const handleStorage = () => {
      setIsCollapsed(localStorage.getItem("spm_sidebar_collapsed") === "true");
    };
    window.addEventListener("storage", handleStorage);
    const interval = setInterval(handleStorage, 300);
    return () => {
      window.removeEventListener("storage", handleStorage);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (env && env !== "PRODUCTION") {
      const prefix = `[${env}]`;
      if (!document.title.startsWith(prefix)) {
        document.title = `${prefix} ${document.title.replace(/^\[.*?\]\s*/, "")}`;
      }
    }
  }, [env]);

  if (!env || env === "PRODUCTION") {
    return null;
  }

  const isDev = env === "DEV" || env === "DEVELOPMENT";
  const label = isDev ? "DESENVOLVIMENTO (DEV)" : "HOMOLOGAÇÃO (HOMOL)";
  const bgColor = isDev ? "#7C3AED" : "#EA580C";

  const isLoginPage = location.pathname === "/" || location.pathname === "/login";
  const isDesktopOrientation = isDesktop && !isTablet && !isMobile && !isLoginPage;
  const sidebarWidth = isCollapsed ? "74px" : "280px";

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: isDesktopOrientation ? sidebarWidth : 0,
        right: 0,
        backgroundColor: bgColor,
        color: "#ffffff",
        textAlign: "center",
        py: 0.5,
        px: 2,
        zIndex: 1100,
        pointerEvents: "none",
        userSelect: "none",
        boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: "0.6px",
          color: "#ffffff",
          userSelect: "none",
          fontFamily: "Inter, sans-serif",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <span>⚠️</span>
        <span>AMBIENTE DE {label} — NÃO UTILIZE DADOS REAIS</span>
        <span>⚠️</span>
      </Typography>
    </Box>
  );
};

export default EnvironmentBanner;
